module.exports = __webpack_public_path__ + "img/selected5-min.0f82e16c.png";